import { apiInstance } from '../../api';

const route = '/apartment/builds';

export class BuildsService {
  static async fetchAllBuilds() {
    return apiInstance.get(route);
  }
}
